var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4865 10.9153C12.4865 7.01695 13.8739 0 13.8739 0L0 16.7627C7.57925 21.2921 12.8864 22.7404 22 23C18.0371 19.837 12.4865 14.8136 12.4865 10.9153Z",
    fill: "#9738FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTail);
export default __webpack_public_path__ + "static/media/right_tail.50968a8aa06adf413dce6429e555f8f7.svg";
export { ForwardRef as ReactComponent };